module.exports = __webpack_public_path__ + "static/media/check-icon.3f0fca1a.webp";